import { Link } from "react-router-dom";
import { ArrowRight, Phone, SearchX } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { notFoundMeta } from "@/seo/routeMeta";
import { SERVICES, PHONE_DISPLAY, PHONE_HREF } from "@/components/site/data";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="bg-white py-20 lg:py-28">
      <Seo {...notFoundMeta()} />
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8">
        <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-brand-surface"><SearchX className="h-8 w-8 text-brand-blue" strokeWidth={1.6} /></span>
        <p className="eyebrow mt-8 justify-center">Error 404</p>
        <h1 className="mt-5 font-heading text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl" data-testid="not-found-heading">We couldn't find that page</h1>
        <p className="lead mx-auto mt-5 max-w-lg">The link may be out of date, or the page may have moved. Here are some helpful places to start instead.</p>
        <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
          <Link to="/" className="btn-primary" data-testid="not-found-home-link">Back to Home <ArrowRight className="h-4 w-4" /></Link>
          <a href={PHONE_HREF} className="btn-secondary" data-testid="not-found-call-link"><Phone className="h-4 w-4" /> Call {PHONE_DISPLAY}</a>
        </div>
        <ul className="mt-12 grid gap-3 text-left sm:grid-cols-2">
          {SERVICES.map((s) => (
            <li key={s.id}>
              <Link to={`/services/${s.slug}`} data-testid={`not-found-service-${s.id}`} className="soft-card flex items-center justify-between gap-3 px-5 py-4 font-heading text-sm font-semibold text-brand-navy transition-colors hover:border-brand-blue/40 hover:text-brand-blue">
                {s.title} <ArrowRight className="h-4 w-4 shrink-0 text-brand-blue" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
